import React, { useEffect, useState, useContext, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import { tableColumns } from './tableColumnsConfig';
import { generateRowData, getColumnWidths } from './utils';
// import AxiosInstance from '../utils/AxiosInstance'; // Disabled until API works
import { stateSummaryData as mockStateSummary, bodyDataByState as mockBodyData } from "../data/mockDailyReportData";
import DefaultRadioTwoTest from './child/DefaultRadioTwoTest';
import { start } from '@popperjs/core';
import FilterContext from "../utils/FilterContext";
import { set } from 'date-fns';

import { useConfig } from "../utils/ConfigContext.jsx";
import {createAxiosInstance} from "../utils/AxiosInstance.jsx";


const DashBoardLayerEightTest = () => {
    const { API_BASE_URL } = useConfig(); // ✅ from context
    const AxiosInstance = createAxiosInstance(API_BASE_URL);

    const { filters, isInitialized } = useContext(FilterContext);
    const filtersRef = useRef(filters);
    const location = useLocation();
    const currentPath = location.pathname;
    const currentPathRef = useRef(currentPath);
    const [isLoading, setIsLoading] = useState(true);

    const [stateSummaryData, setStateSummaryData] = useState([]);
    const [bodyDataByState, setBodyDataByState] = useState({});
    const [selectedStates, setSelectedStates] = useState([]);
    const [openPanels, setOpenPanels] = useState({});
    const [selectedStateType, setSelectedStateType] = useState([]);
    const [selectedColumnType, setSelectedColumnType] = useState('lead');
    const [filtertedTableColumns, setFiltertedTableColumns] = useState(tableColumns);
    const matchColumnsWithTypes = {
        'lead': ['Opening Lead Balance', 'Total Opening Lead Balance', 'Live Calls', 'Today Lead Update', 'Total Today Lead Update', 'Closing Lead Update', 'Total Closing Lead Balance'],
        'patient': ['Patients(OPD)'],
        'treatment': ['Treatments'],
    };
    const widths = getColumnWidths(filtertedTableColumns);

    useEffect(() => {

        if (filtersRef.current !== filters) {
            filtersRef.current = filters;
            // console.log("Calling getStateValue with filters:", filters);
            getStateValue([null, true, false, false]);
        }
        // console.log(openPanels);
        // let startDate, endDate;
        // if (Object.keys(openPanels).length != 0) {
        //     if (filters?.dateRange) {
        //         const [start, end] = filters.dateRange.split(" - ");
        //         if (start && end) {
        //             startDate = start.trim();
        //             endDate = end.trim();
        //         }
        //     } else {
        //         startDate = getDefaultStartDate();
        //         endDate = getDefaultEndDate();
        //     }


        //     Object.entries(openPanels).forEach(([key, value]) => {
        //         loadCenterAccordionData(key, [startDate, endDate], setBodyDataByState);
        //     });
        // }
        // loadCenterAccordionData()
    }, [filters]);
    useEffect(() => {
        // Simulate API with local file
        filterColumns(selectedColumnType);
    }, [selectedColumnType]);

    const getStateValue = (getStateValueArray) => {
        setIsLoading(true);
        const checked = getStateValueArray.map((v, k) => v ? k : null).filter(k => k !== null);
        let startDate, endDate;
        // console.log("filterrrr", filters);

        if (filters?.dateRange) {
            const [start, end] = filters.dateRange.split(" - ");
            if (start && end) {
                startDate = start.trim();
                endDate = end.trim();
            }
        } else {
            startDate = getDefaultStartDate();
            endDate = getDefaultEndDate();
            // console.log("dfjr", startDate, endDate);

        }
        AxiosInstance.post("/reports/daily-state", {
            startDate: startDate,
            endDate: endDate,
            hospital_typ: checked
        }).then((res) => {
            const formatted = [];
            let index = 1;
            setIsLoading(false);
            Object.entries(res.data.summary).forEach(([stateName, item]) => {

                formatted.push({
                    "lengthy": item ? item.length : 0,
                    "#": index++,
                    "Center Name": stateName,
                    "Date": '--',

                    // Opening
                    opening_pending_follow_up: "N/A",
                    opening_today_schedule: "N/A",
                    opening_pending_till_yesterday: "N/A",
                    opening_new_leads_after_closing: item.lead_schedule ?? "N/A",
                    total_opening_lead_balance: "N/A",

                    // Live Calls
                    live_ongoing_calls: "N/A",
                    live_incoming_calls: "N/A",
                    live_missed_calls: "N/A",
                    live_rejected_calls: "N/A",

                    // Today Lead Update
                    today_new: item.lead_new ?? "N/A",
                    today_follow_ups: item.lead_follow_up ?? "N/A",
                    today_close: item.lead_closed ?? "N/A",
                    today_convert_to_opd: item.lead_converted ?? "N/A",
                    today_transfer_to_center: item.lead_transferred ?? "N/A",
                    total_today_lead_update: [item.lead_new, item.lead_follow_up, item.lead_closed, item.lead_converted, item.lead_transferred]
                        .map(x => isNaN(x) ? 0 : Number(x))
                        .reduce((a, b) => a + b, 0),

                    // Closing
                    closing_pending_follow_ups: "N/A",
                    closing_pending_new_leads: "N/A",
                    total_closing_lead_balance: "N/A",

                    // OPD
                    opd_scheduled: item.app_scheduled ?? "N/A",
                    opd_cancel: item.app_cancelled ?? "N/A",
                    opd_finished: item.app_finished ?? "N/A",
                    opd_transfer: item.transfer_to_center || "N/A",
                    opd_treatment: item.pkg_book || "N/A",
                    opd_investigation: item.investigation || "N/A",

                    // Patients / Treatment
                    treatment_machines: item.machine_count || "N/A",
                    treatment_running: item.running_patient || "N/A",
                    treatment_added_today: item.patient_added_today || "N/A",
                    treatment_finished_today: item.app_finished ?? "N/A",
                    treatment_net_running: "N/A",
                    treatment_transferred: item.patient_transfer_today || "N/A",
                    treatment_net_finished: "N/A",

                    treatment_cui: item.cui_percentage ?? "N/A",
                    treatment_schedule_based: item.total_slot_time ?? "N/A",
                    treatment_crm_based: item.completed_slot_time ?? "N/A",
                    treatment_compression_based: item.compression_time ?? "N/A"
                });
            });

            setStateSummaryData(formatted);
        });
    };



    const getColumnValue = (getColumnValueArray) => {

        let checkedColumnValueArray;
        Object.entries(getColumnValueArray).forEach(([key, value]) => {
            if (value) {
                checkedColumnValueArray = key;
            }
        });
        setSelectedColumnType(checkedColumnValueArray);
    };

    // const renderHmName = (name, status) => {
    //     let icon = "";
    //     if (typeof status === "string" && status.toLowerCase().includes("pending")) {
    //         icon = '<i class="ri-close-circle-fill text-danger fs-4"></i>';
    //     } else {
    //         icon = '<i class="ri-verified-badge-fill text-success fs-5"></i>';
    //     }
    //     return `
    //         <div class="d-flex align-items-center justify-content-start">
    //             ${icon}
    //             <span class="text-primary ms-2">${name}</span>
    //         </div>
    //     `;
    // };

    const filterColumns = (columnValue) => {

        setFiltertedTableColumns(tableColumns.filter((col) => {
            if (
                matchColumnsWithTypes[columnValue].includes(col.label) ||
                col.label === '#' ||
                col.label === 'Center Name' ||
                col.label === 'Date'
            ) {
                return col;
            }
        }));
    }

    const loadCenterAccordionData = async (centerName, dateRange, setBodyDataByState) => {
        try {
            const [startDate, endDate] = dateRange || [getDefaultStartDate(), getDefaultEndDate()];
            const response = await AxiosInstance.post("/reports/daily", {
                startDate,
                endDate,
                center_id: "",
                state: centerName,
                hospital_typ: [],
            });

            const formatted = response.data.data.map((item, i) => ({
                "#": i + 1,
                "Center Name": item.hm_name,
                "Date": item.created_date || new Date().toISOString().split("T")[0],
                "status": item.status || "N/A",
                treatment_machines: item.machine_count ?? "N/A",
                treatment_running: item.running_patient ?? "N/A",
                treatment_added_today: item.patient_added_today ?? "N/A",
                treatment_finished_today: item.finished_treatments ?? "N/A",
                treatment_net_running: item.running_treatments ?? "N/A",
                treatment_transferred: item.patient_transfer_today ?? "N/A",
                treatment_net_finished: item.treatment_counts ?? "N/A",
                treatment_cui: item.cui_percentage ?? "N/A",
                treatment_schedule_based: item.total_slot_time ?? "N/A",
                treatment_crm_based: item.completed_slot_time ?? "N/A",
                treatment_compression_based: item.compression_time ?? "N/A",

                opening_pending_follow_up: "N/A",
                opening_today_schedule: "N/A",
                opening_pending_till_yesterday: "N/A",
                opening_new_leads_after_closing: item.lead_schedule ?? "N/A",
                total_opening_lead_balance: item.total_opening_lead_balance ?? "N/A",

                live_ongoing_calls: item.live_calls ?? "N/A",
                live_incoming_calls: item.incoming_calls ?? "N/A",
                live_missed_calls: item.missed_calls ?? "N/A",
                live_rejected_calls: item.rejected_calls_by_us ?? "N/A",

                today_new: item.lead_new ?? "N/A",
                today_follow_ups: item.lead_follow_up ?? "N/A",
                today_close: item.lead_closed ?? "N/A",
                today_convert_to_opd: item.lead_converted ?? "N/A",
                today_transfer_to_center: item.lead_transferred ?? "N/A",
                total_today_lead_update:
                    [item.lead_new, item.lead_follow_up, item.lead_closed, item.lead_converted, item.lead_transferred]
                        .map(v => isNaN(v) ? 0 : Number(v))
                        .reduce((a, b) => a + b, 0),

                closing_pending_follow_ups: item.pending_follow_ups ?? "N/A",
                closing_pending_new_leads: item.pending_new_leads ?? "N/A",
                total_closing_lead_balance: item.total_closing_balance ?? "N/A",

                opd_scheduled: item.app_scheduled ?? "N/A",
                opd_cancel: item.app_cancelled ?? "N/A",
                opd_finished: item.app_finished ?? "N/A",
                opd_transfer: item.transfer_to_center ?? "N/A",
                opd_treatment: item.pkg_book ?? "N/A",
                opd_investigation: item.investigation ?? "N/A",
            }));

            setBodyDataByState(prev => ({
                ...prev,
                [centerName]: formatted,
            }));
        } catch (error) {
            console.error("❌ Error loading accordion body data:", error);
        }
    };


    const togglePanel = async (id, centerName, dateRange) => {
        const isCurrentlyOpen = openPanels[id];

        setOpenPanels(prev => ({
            ...prev,
            [id]: !prev[id],
        }));

        // Always load fresh data on open
        // ✅ Only call API if it's being opened (not already open)
        let startDate, endDate;
        if (filters?.dateRange) {
            const [start, end] = filters.dateRange.split(" - ");
            if (start && end) {
                startDate = start.trim();
                endDate = end.trim();
            }
        } else {
            startDate = getDefaultStartDate();
            endDate = getDefaultEndDate();
        }
        dateRange = [startDate, endDate];
        if (!isCurrentlyOpen) {
            await loadCenterAccordionData(centerName, dateRange, setBodyDataByState);
        }
    };


    const getDefaultStartDate = () => {
        const d = new Date();
        d.setDate(d.getDate() - 1);
        return d.toISOString().split("T")[0];
    };

    const getDefaultEndDate = () => {
        return new Date().toISOString().split("T")[0];
    };



    return (
        <>
            <DefaultRadioTwoTest getStateValue={getStateValue} getColumnValue={getColumnValue} />
            <div className="DailyReportTableTest" style={{ overflowX: 'auto', height: '400px', width: '100%' }}>
                <div style={{ minWidth: widths.reduce((sum, w) => sum + parseFloat(w), 0) + 2 + 'px' }}>
                    <TableHeader columns={filtertedTableColumns} />

                    {isLoading ? (
                        <div className="d-flex align-items-center justify-content-start">
                            <div className="loader"></div>
                        </div>
                    ) : (
                        <div className="accordion" id="accordionExample">
                            {stateSummaryData.map((item, index) => {
                                const id = item["Center Name"];
                                const isOpen = openPanels[id];
                                const isDisabled = item.lengthy === 0;
                                return (
                                    <div key={id} className={`accordion-item bg_sky ${isDisabled ? 'disabled-section' : ''}`}>
                                        <h2 className="accordion-header">
                                            <div
                                                className={`accordion-button bg_sky ${isOpen ? '' : 'collapsed'}`}
                                                onClick={() => !isDisabled && togglePanel(id, id)}
                                                style={{ padding: 0 }}
                                            >
                                                <TableRow
                                                    key={`row-${id}`}
                                                    data={generateRowData(item, filtertedTableColumns)}
                                                    widths={widths}
                                                    variant="accordion"
                                                />
                                            </div>
                                        </h2>
                                        <div className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}>
                                            <div className="accordion-body p-0">
                                                {(bodyDataByState[id] || []).map((row, i) => (
                                                    <TableRow
                                                        key={`body-${id}-${i}`}
                                                        data={generateRowData(row, filtertedTableColumns)}
                                                        widths={widths}
                                                        variant="body"
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </>
    );



};

export default DashBoardLayerEightTest;
